<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.custodianMonthlyReport')"
    resource="custodian_monthly_reports"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/custodian_monthly_reports.js';
import ReportContentEditor from '@/components/report-content-editor';

@Component
export default class CustodianMonthlyReports extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'title',
      'announced_at',
      'published_at',
      type === 'show' && 'content_type',
      type === 'show' && { key: 'content', renderCell: { component: 'html' }  },
      type === 'show' && { key: 'markdown_content', renderCell: { component: 'richText', props: { type: 'markdown' } }  },
      'fund',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'title',
      'fund_id',
      'announced_at',
      'content_type',
      {
        key: 'content',
        renderCell: {
          // 插件对 function 类型的 component 会当作渲染函数调用，类组件需包一层
          component: (h, context) => h(ReportContentEditor, context)
        }
      },
      {
        key: 'markdown_content',
        renderCell: {
          // 同 content，插入格式为 markdown 图片语法
          component: (h, context) => h(ReportContentEditor, { ...context, props: { ...context.props, format: 'markdown' } })
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    const handlePublish = async (id) => {
      await this.$autoLoading(this.$request.put(`/custodian_monthly_reports/${id}/published_at_to_time_current`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'custodian_monthly_reports.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'custodian_monthly_reports.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      },
      !row.published_at && {
        component: 'confirmButton',
        props: {
          label: this.$t('customPage.publish'),
          type: 'primary',
          can: 'custodian_monthly_reports.update'
        },
        on: {
          confirm: () => handlePublish(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/custodian_monthly_reports',
    name: 'custodian_monthly_reports.index',
    component: CustodianMonthlyReports,
    props: {
      type: 'index',
    }
  },
  {
    path: '/custodian_monthly_reports/new',
    name: 'custodian_monthly_reports.new',
    component: CustodianMonthlyReports,
    props: {
      type: 'new',
    }
  },
  {
    path: '/custodian_monthly_reports/:id',
    name: 'custodian_monthly_reports.show',
    component: CustodianMonthlyReports,
    props: {
      type: 'show',
    }
  },
  {
    path: '/custodian_monthly_reports/:id/edit',
    name: 'custodian_monthly_reports.edit',
    component: CustodianMonthlyReports,
    props: {
      type: 'edit'
    }
  }
]
</script>
